import api from "./api";

export const getDocumentUrl = async (documentId: string): Promise<string> => {
  const response = await api.get(
    `documents/documents/${documentId}/inline/`,
    { responseType: 'blob' }
  );
  
  return URL.createObjectURL(response.data);
};